import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconImprove = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 32 32"
    data-fill-none
  >
    <path
      d="M13.8247 12.2885C11.1981 10.4964 6.83798 10.9962 6.19842 13.4675C6.09802 13.8554 6.32902 14.2341 6.67227 14.4409L11.0294 17.0657"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7112 18.1772C21.5034 20.8039 21.0051 25.1643 18.5323 25.8035C18.1443 25.9038 17.7656 25.6728 17.5589 25.3296L14.9341 20.9725"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0288 17.0533L14.9481 20.9726C18.0836 19.0943 21.648 17.2751 23.2748 15.5891C26.0066 12.8573 25.3891 9.34156 24.9755 7.90406C24.8523 7.47596 24.5254 7.14905 24.0973 7.02588C22.6598 6.61233 19.1441 5.99474 16.4123 8.72653C14.7263 10.3534 12.8923 13.9326 11.0288 17.0533Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6717 22.699C11.3371 24.0336 8.84835 23.3865 8.84835 23.3865C8.84835 23.3865 8.30105 20.7983 9.53624 19.5635"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconImprove.displayName = 'IconImprove';
